import { DatePicker } from 'cleveron-web-components';
import { format } from 'date-fns';
import React, { useEffect } from 'react';
import { Field, useForm } from 'react-final-form';

import { useFormValues } from '../../../../../../form';

function ActualDateForm({ disabled, id }) {
    const { change } = useForm();
    const { actualDateTmp } = useFormValues(['actualDateTmp'], { ignoreFocused: true });

    useEffect(() => {
        try {
            if (actualDateTmp instanceof Date && actualDateTmp.getFullYear() >= 1000) {
                change('actualDate', format(actualDateTmp, 'yyyy-MM-dd'));
            } else if (!actualDateTmp) {
                change('actualDate', null);
            }
        } catch {
            //
        }
    }, [actualDateTmp, change]);

    return (
        <>
            <Field component="input" hidden name="actualDate" />
            <Field
                component={DatePicker}
                disabled={disabled}
                id={`${id}ActualDate`}
                name="actualDateTmp"
            />
        </>
    );
}

export default ActualDateForm;
